// API configuration
export const API_URL = process.env.REACT_APP_API_URL;

// Environment settings
export const isProduction = process.env.NODE_ENV === 'production';

// Enterprise configuration
export const ENTERPRISE_SETUP_CODE = process.env.REACT_APP_ENTERPRISE_SETUP_CODE || 'TRANZCRIBE-SETUP-2025';

// Function to get versioned API endpoints
export const getApiEndpoint = (endpoint: string) => {
  return `${API_URL}/${endpoint}`;
}; 